import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../../../redux/title/title.slice';

function NoAccess() {
  const dispatch = useDispatch();
  const mainColor = '#CC6323';

  useEffect(() => {
    dispatch(setPageTitle('No Access'));
  }, [dispatch]);

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2
      }}>
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: 520
        }}>
        {/* No access animation */}
        <Box
          sx={{
            position: 'relative',
            width: 100,
            height: 100,
            mx: 'auto',
            mb: 4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          {/* Animated outer circle */}
          <Box
            sx={{
              position: 'absolute',
              width: 100,
              height: 100,
              border: `1px solid ${mainColor}`,
              borderRadius: '50%',
              opacity: 0.25,
              animation: 'pulse 2s ease-in-out infinite',

              '@keyframes pulse': {
                '0%, 100%': {
                  transform: 'scale(0.9)',
                  opacity: 0.2
                },
                '50%': {
                  transform: 'scale(1.05)',
                  opacity: 0.45
                }
              }
            }}
          />

          {/* Lock */}
          <Box
            sx={{
              position: 'relative',
              width: 42,
              height: 34,
              mt: 2,
              backgroundColor: mainColor,
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              animation: 'lockFloat 2s ease-in-out infinite',

              '@keyframes lockFloat': {
                '0%, 100%': {
                  transform: 'translateY(0)'
                },
                '50%': {
                  transform: 'translateY(-4px)'
                }
              },

              '&::before': {
                content: '""',
                position: 'absolute',
                width: 24,
                height: 28,
                border: `5px solid ${mainColor}`,
                borderBottom: '0',
                borderRadius: '14px 14px 0 0',
                top: -22,
                left: 9
              },

              '&::after': {
                content: '""',
                position: 'absolute',
                width: 5,
                height: 11,
                backgroundColor: 'var(--ft-white)',
                borderRadius: 3,
                top: 11,
                left: '50%',
                transform: 'translateX(-50%)'
              }
            }}
          />
        </Box>

        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            color: mainColor,
            mb: 2
          }}>
          Access Restricted
        </Typography>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          You don't have access to this page.
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            lineHeight: 1.6
          }}>
          Your account does not have the required permissions to view this page. If you believe you
          should have access, please contact your advisor or our support team for assistance.
        </Typography>
      </Box>
    </Box>
  );
}

export default NoAccess;
